import type { ResolutionsListFiltersContext as ResolutionsListFiltersContextType } from '@library/types/resolutions/resolutionsList';
import { createContext } from 'react';
import { defaultResolutionListFilters } from '@bo-constants/resolutions/resolutionsList';

export const ResolutionsListFiltersContext =
  createContext<ResolutionsListFiltersContextType>({
    adminUserOptions: [],
    currentPage: 1,
    onAdminUserChange: () => {},
    onCompletedOnChange: () => {},
    onCreatedAtChange: () => {},
    onCurrentPageChange: () => {},
    onResetCurrentPageChange: () => {},
    onResetFilters: () => {},
    onResolutionStatusChange: () => {},
    resolutionListFilters: defaultResolutionListFilters,
    resolutionStatusOptions: []
  });
